<template>
  <div class="d-flex flex-row align-items-end float-right meta">
    <div class="px-1 font-weight-bold">{{ getAuthorName(author) }}</div>
    <div class="px-1">{{ formatDate(when) }}</div>
  </div>
</template>
<script>
import { DateTime } from "luxon";

export default {
  props: { author: {}, when: {}, users: {} },
  methods: {
    getAuthorName(authorId) {
      var user = this.users[authorId];
      if (!user) {
        user = { first_name: "Unknown", last_name: "Unknown" };
      }
      const firstname = user.first_name;
      const lastname = user.last_name;
      return firstname + " " + lastname;
    },
    formatDate(paramDate) {
      const date = DateTime.fromISO(paramDate);
      const humanReadable = date.toLocaleString(DateTime.DATETIME_MED);
      return humanReadable;
    },
  },
};
</script>
<style>
.meta {
  font-size: 8pt;
}
</style>
